import { Wallet, ShieldCheck, Wrench, LineChart, Building2, Receipt, Users, Headphones } from "lucide-react";
import { HOST_IMG, HERO_IMG } from "@/lib/brand";
import { EnquiryForm } from "@/components/site/EnquiryForm";

const base = [
  { key: "name", label: "Full name", required: true },
  { key: "phone", label: "Mobile number", required: true, placeholder: "10-digit mobile number" },
  { key: "email", label: "Email", type: "email" },
];

function Perks({ items }) {
  return (
    <div className="mt-10 grid gap-5 sm:grid-cols-2">
      {items.map(([I, t, d]) => (
        <div key={t} className="rounded-2xl border border-black/5 bg-white p-5">
          <I className="h-7 w-7 text-[#FF5A00]" strokeWidth={1.75} />
          <p className="mt-4 font-semibold">{t}</p>
          <p className="mt-1 text-sm text-neutral-600">{d}</p>
        </div>
      ))}
    </div>
  );
}

function Page({ testId, img, eyebrow, title, sub, perks, form }) {
  return (
    <div data-testid={testId}>
      <section className="relative overflow-hidden bg-neutral-950">
        <img src={img} alt="" className="absolute inset-0 h-full w-full object-cover opacity-50" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 to-black/20" />
        <div className="container-x relative py-20 sm:py-28">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#FF8A3D]">{eyebrow}</p>
          <h1 className="mt-4 max-w-2xl text-4xl font-bold leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl">{title}</h1>
          <p className="mt-5 max-w-lg text-base text-white/80 md:text-lg">{sub}</p>
        </div>
      </section>
      <section className="container-x grid gap-12 py-16 lg:grid-cols-[1.2fr_1fr]">
        <div>
          <h2 className="text-2xl font-bold tracking-tight sm:text-3xl">Why partner with Hoorecars</h2>
          <Perks items={perks} />
        </div>
        <div className="lg:sticky lg:top-24 lg:h-fit">{form}</div>
      </section>
    </div>
  );
}

export function HostPage() {
  return (
    <Page testId="host-page" img={HOST_IMG} eyebrow="Host & Earn" title="Turn your idle car into monthly income."
      sub="List your car with Hoorecars. We handle bookings, verified renters, cleaning and support — you earn."
      perks={[[Wallet, "Regular payouts", "Earnings credited to your bank account on a fixed schedule."], [ShieldCheck, "Verified renters only", "Every renter passes licence, Aadhaar and live selfie checks."], [Wrench, "Care & inspection", "Photo inspections at every pickup and return protect your car."], [LineChart, "Live tracking", "GPS location of your car during every trip."]]}
      form={<EnquiryForm type="host" testPrefix="host" cta="Start Hosting"
        fields={[...base, { key: "car", label: "Car make, model & year", required: true, placeholder: "e.g. Hyundai Creta 2023" }, { key: "city", label: "City", placeholder: "Bengaluru" }, { key: "message", label: "Anything else?", textarea: true }]} />} />
  );
}

export function BusinessPage() {
  return (
    <Page testId="business-page" img={HERO_IMG} eyebrow="Hoorecars for Business" title="Cars for your team, on demand."
      sub="Self-drive or chauffeur-driven cars for employee travel, client visits and events — with monthly GST billing."
      perks={[[Building2, "Corporate accounts", "One account for your whole team with central billing."], [Receipt, "GST invoices", "Every trip billed with input-tax-credit ready GST invoices."], [Users, "With-driver option", "Professional drivers assigned by Hoorecars for ₹1,299 per day."], [Headphones, "Dedicated support", "A single point of contact for bookings and changes."]]}
      form={<EnquiryForm type="business" testPrefix="business" cta="Request a callback"
        fields={[...base, { key: "company", label: "Company name", required: true }, { key: "city", label: "City", placeholder: "Bengaluru" }, { key: "message", label: "Your requirement", textarea: true, placeholder: "e.g. 3 SUVs with drivers every month" }]} />} />
  );
}
